import React, { Suspense, lazy, useEffect ,useState} from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import PrivateRoute from "./services/PrivateRoute/PrivateRoute";
import ErrorElement from "./components/common/ErrorElement/ErrorElement";
import AppLoader from "./components/common/AppLoader/AppLoader";
import ItemsTab from "./tabs/OrganisationTabs/ItemsTab/ItemsTab";
import BuyerItemsTab from "./tabs/BuyerTabs/ItemsTab/ItemsTab";
import BudgetMaster from "./tabs/BuyerTabs/BudgetMaster/BudgetMaster";
import RFQTab from "./tabs/OrganisationTabs/RFQTab/RFQTab";
import BuyerRFQTab from "./tabs/BuyerTabs/RFQTab/RFQTab";
import BuyerRFQDraftTab from "./tabs/BuyerTabs/RFQDraftTab/RFQDraftTab";
import PrivacyPolicyLayout from "./pages/HomePage/Legals/PrivacyPolicy/PrivacyPolicyLayout";
import CookiePolicyLayout from "./pages/HomePage/Legals/CookiePolicy/CookiePolicyLayout";
import DashboardTab from "./tabs/OrganisationTabs/DashboardTab/DashboardTab";
import BuyerDashboardTab from "./tabs/BuyerTabs/DashboardTab/BuyerDashboardTab";
import VendorDashboardTab from "./tabs/VendorsTabs/VendorDashboardTab/VendorDashboardTab";
import ComparisonTab from "./tabs/BuyerTabs/ComparisonTab/ComparisonTab";
import Prompt from "./tabs/OrganisationTabs/Prompt/Prompt";
import PromptCreation from "./tabs/OrganisationTabs/Prompt/PromptCreation";
import PoTab from "./tabs/BuyerTabs/PoTab/PoTab";
import SlabConfig from "./tabs/OrganisationTabs/slabConfig/slab";
// CostCenter
import CostCenterTab from "./tabs/OrganisationTabs/CostCenterTab/CostCenterTab";
import GLTab from "./tabs/OrganisationTabs/GLTab/GLTab";
import ProjectsTab from "./tabs/OrganisationTabs/ProjectsTab/ProjectsTab";
// Gst
import GstTab from "./tabs/OrganisationTabs/GstTab/GstTab";
import Chat_System from "./tabs/ChatTab/Chat";
import GRNSystem from "./tabs/BuyerTabs/GRNTabs/GRNTabPage";
import MRPTab from "./tabs/BuyerTabs/MRPTab/MRPTab";
import InventoryTab from "./tabs/BuyerTabs/InventoryTabs/InventoryTab";
import InventoryMasterWarehouse from "./tabs/BuyerTabs/InventoryMasterWarehouse/InventoryMasterWarehouse";
import AssetRegisterTab from "./tabs/BuyerTabs/AssetRegister/AssetRegisterTab";
import QuickRFQ from "./tabs/BuyerTabs/RFQTab/QuickRFQ";
import FreeRFQ from "./tabs/BuyerTabs/RFQTab/FreeRFQ";
import FreeRFQCreate from "./tabs/BuyerTabs/RFQTab/FreeRFQCreate";
import FreeRFQDetails from "./tabs/BuyerTabs/RFQTab/FreeRFQDetails";
import FreeRFQDocumentExtraction from "./pages/FreeRFQDocumentExtraction/FreeRFQDocumentExtraction";
import SalesInvoiceTab from "./tabs/BuyerTabs/SalesInvoiceTab/SalesInvoiceTab";
import { PurchaseRequisitionTab } from "./tabs/BuyerTabs/PRTab/PrTab";
import ThreeWayMactcing from "./tabs/BuyerTabs/ThreeWayMatching/ThreeWayMatching";
import PRApproverSlab from "./tabs/BuyerTabs/PRTab/PRApproverSlab";
import VendorInvite from "./tabs/BuyerTabs/VendorInvite/VendorInvite";
import VendorInvoice from "./tabs/VendorsTabs/Invoice/Invoice";
import ApproverInvoice from "./tabs/VendorsTabs/Invoice/ApproverInvoice";
import CreditUserDashboard from "./pages/CreditUsersDashboard/CreditUserDashboard";
import VendorApproval from "./tabs/BuyerTabs/Vendor Approval/VendorApprovals";
import ApprovalSlab from "./tabs/BuyerTabs/Vendor Approval/VendorApprovalSlab";
import VendorApprovalSlab from "./tabs/BuyerTabs/Vendor Approval/VendorApprovalSlab";
import VendorVerifciationPartial from "./tabs/BuyerTabs/VendorVerification/VendorVerifcation";
import VendorTabLayout from "./tabs/BuyerTabs/VendorsTab/VendorTabLayout";
import UnifiedOnboarding from "./tabs/BuyerTabs/UnifiedOnboarding/UnifiedOnboarding";
import UserAccess from "./tabs/Admin/UserAccess";
import LandingPage from "./pages/LandingPage/LandingPage";
import InvoiceAutomation from "./tabs/BuyerTabs/InvoiceAutomation/InvoiceAutomation";
import ChatWidget from "./components/Chatbot/ChatWidget";
import DemoInvoiceAutomation from "./tabs/BuyerTabs/InvoiceAutomation/DemoInvoiceAutomation";
import NewComparison from "./tabs/BuyerTabs/ComparisonTab/NewComparison";
import PanToCinUploader from "./tabs/BuyerTabs/ComparisonTab/IDFY";
import ItemVendorMap from "./tabs/BuyerTabs/InvoiceAutomation/ItemVendorMap";
import { PayPerUseHome } from "./tabs/BuyerTabs/PayPerUse/PayPerUseHome";
import TWMSlabConfig from "./tabs/BuyerTabs/ThreeWayMatching/TWMSlabConfig";
import { TWMHome } from "./tabs/BuyerTabs/ThreeWayMatching/TWMHome";
import InviteBuyerAdmin from "./tabs/Admin/InviteBuyerAdmin";
import ComparisonHome from "./tabs/BuyerTabs/ComparisonTab/ComparisonHome";
import GlobalLoader from "./components/common/AppLoader/GlobalLoader";
import RateContract from "./tabs/BuyerTabs/RateContract/RateContract";
import InvoiceProcess from "./tabs/VendorsTabs/InvoiceProcess/InvoiceProcess";
import AddInvoice from "./tabs/VendorsTabs/InvoiceProcess/AddInvoice";
import InvoiceReconciliation from "./tabs/BuyerTabs/InvoiceReconciliation/InvoiceReconciliation";
import VendorPOTab from "./tabs/VendorsTabs/VendorPOTab/VendorPOTab";
import UserLogs from "./tabs/Admin/UserLogs";
import AIUsageCostAccuracy from "./tabs/Admin/AIUsageCostAccuracy";
import ManageOfflinePassword from "./tabs/OrganisationTabs/MyProfile/ManageOfflinePassword";
import PriceList from "./tabs/BuyerTabs/PriceList/PriceList";
import PriceListQuotationView from "./tabs/BuyerTabs/PriceList/PriceListQuotationView";
import SourcingIntelligence from "./tabs/BuyerTabs/SourcingIntelligence/SourcingIntelligence.jsx";
import ServiceMatchingHome from "./tabs/BuyerTabs/ServiceMatching/ServiceMatchingHome.jsx";
import UnregisteredVendorCatalogTab from "./tabs/UnregisteredVendorTabs/CatalogTab/CatalogTab";
import UnregisteredVendorCatalogAdd from "./tabs/UnregisteredVendorTabs/CatalogTab/CatalogAdd";
import UnregisteredVendorMyProfile from "./tabs/UnregisteredVendorTabs/MyProfile/MyProfile";

import OfflinePasswordModal from "./components/common/ProfileCard/OfflinePasswordModal";
import useNetworkStatus from "./hooks/useNetworkStatus";
import useOfflineIdle from "./hooks/useOfflineIdle";
import NotificationRealtime from "./components/common/NotificationRealtime/NotificationRealtime";

import GRNDetails from "./tabs/BuyerTabs/GRNTabs/GRNDetails";
import PublicSubmission from "./pages/EmailResponse/PublicSubmission.jsx";

// Lazy-loaded components
const LoginPage = lazy(() => import("./pages/LoginPage/LoginPage"));
const AdminLoginPage = lazy(() => import("./pages/AdminLogin/AdminLogin"));
const UnregisteredVendorRegister = lazy(
  () => import("./pages/UnregisteredVendorRegister/UnregisteredVendorRegister"),
);
const RFISignup = lazy(() => import("./pages/RFISignup/RFISignup"));
const HomePage = lazy(() => import("./pages/HomePage/HomePage"));
const BuyerSignup = lazy(() => import("./pages/BuyerSignup/BuyerSignup"));

const VendorSignup = lazy(() => import("./pages/VendorSignup/VendorSignup"));
const UnifiedOnboardingApplication = lazy(
  () => import("./pages/UnifiedOnboardingApplication/VendorSignup"),
);
const DemoVendorSignup = lazy(
  () => import("./pages/VendorSignup/DemoVendorSignup"),
);

const AdminDashboard = lazy(
  () => import("./pages/AdminDashboard/AdminDashboard"),
);
const OrganisationDashboard = lazy(
  () => import("./pages/OrganisationDashboard/OrganisationDashboard"),
);

const BuyerDashboard = lazy(
  () => import("./pages/BuyerDashboard/BuyerDashboard"),
);
const BuyersTab = lazy(
  () => import("./tabs/OrganisationTabs/BuyersTab/BuyersTab"),
);
const VendorsTab = lazy(
  () => import("./tabs/OrganisationTabs/VendorsTab/VendorsTab"),
);
const BuyerVendorsTab = lazy(
  () => import("./tabs/BuyerTabs/VendorsTab/VendorsTab"),
);
const MyProfile = lazy(
  () => import("./tabs/OrganisationTabs/MyProfile/MyProfile"),
);


const VendorDashboard = lazy(
  () => import("./pages/VendorDashboard/VendorDashboard"),
);
const UnregisteredVendorDashboard = lazy(
  () => import("./pages/UnregisteredVendorDashboard/UnregisteredVendorDashboard"),
);
const VendorProfile = lazy(
  () => import("./tabs/VendorsTabs/VendorProfile/VendorProfile"),
);
const VendorRFQTab = lazy(
  () => import("./tabs/VendorsTabs/VendorRFQTab/VendorRFQTab"),
);
const VendorUsersTab = lazy(
  () => import("./tabs/VendorsTabs/VendorUsersTab/VendorUsersTab"),
);

const ChatPage = lazy(() => import("./pages/ChatDashboard/ChatCommunication"));

const GrnPage = lazy(() => import("./pages/GRNDashboard/GRNDashboardPage"));

const CreditUser = lazy(
  () => import("./pages/CreditUsersDashboard/CreditUserDashboard"),
);

// const ChatTab = lazy(() => {
//   import("./tabs/ChatTab")
// })import invoiceProcess from './tabs/VendorsTabs/InvoiceProcess/InvoiceProcess';

const getAuthToken = () => {
  try {
    const mainData = JSON.parse(localStorage.getItem("persist:main"));
    if (!mainData || !mainData.value) return null;

    const parsedValue = JSON.parse(mainData.value);
    return parsedValue?.token || null;
  } catch {
    return null;
  }
};

// App.js or MainLayout.jsx

function App() {


  const isOnline = useNetworkStatus();
  const [offlinePopupOpen, setOfflinePopupOpen] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash || "");

  useEffect(() => {
    if (!isOnline) {
      setOfflinePopupOpen(true);
    }
    else{
      setOfflinePopupOpen(false)
    }


  }, [isOnline]);

  useOfflineIdle(isOnline, () => {
    setOfflinePopupOpen(true);
  }, 300000); 

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash || "");
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const isDocumentExtractionPage =
    currentHash.includes("/free-rfq-document-extraction") ||
    currentHash.split("?")[0] === "#/easy-rfq";

 
  return (
    <div className="main">
      <GlobalLoader />
      <Router>
        <NotificationRealtime />
        {!isDocumentExtractionPage && <ChatWidget />}
        <Suspense fallback={<AppLoader fullScreen />}>
          <Routes>
            <Route
              path="/easy-rfq"
              element={<FreeRFQDocumentExtraction />}
            />
            <Route
              path="/free-rfq-document-extraction"
              element={<FreeRFQDocumentExtraction />}
            />
            <Route path="/welcome" element={<LandingPage />} />
            <Route path="*" element={<ErrorElement />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/ai_dialogue" element={<AdminLoginPage />} />
            <Route
              path="/unregistered_vendor/register"
              element={<UnregisteredVendorRegister />}
            />
            <Route path="/rfi_signup" element={<RFISignup />} />
            <Route path="/privacy" element={<PrivacyPolicyLayout />} />
            <Route path="/cookie" element={<CookiePolicyLayout />} />
            <Route
              path="/admin"
              element={<PrivateRoute Element={AdminDashboard} />}
            >
              <Route index element={<UserAccess />} />
              <Route path="buyer_access" element={<UserAccess />} />
              <Route path="invitebuyeradmin" element={<InviteBuyerAdmin />} />
              <Route path="UserLogs" element={<UserLogs />} />
              <Route path="AIUsageCost" element={<AIUsageCostAccuracy />} />
              <Route path="Prompt" element={<Prompt />} />
              <Route path="Prompt_creation" element={<PromptCreation />} />
            </Route>
            <Route
              path="/Organization_dashboard"
              element={<PrivateRoute Element={OrganisationDashboard} />}
            >
              <Route index element={<DashboardTab />} />
              <Route path="Dashboard" element={<DashboardTab />} />
              <Route path="buyers" element={<BuyersTab />} />
              <Route path="vendors" element={<VendorsTab />} />
              <Route path="RFQ" element={<RFQTab />} />
              <Route path="items" element={<ItemsTab />} />
              <Route path="BudgetMaster" element={<BudgetMaster />} />
              <Route path="My_profile" element={<MyProfile />} />
              <Route
                path="manage-offline-password"
                element={<ManageOfflinePassword />}
              />
              <Route path="slab" element={<SlabConfig />} />
              <Route path="PRSlab" element={<PRApproverSlab />} />
              <Route path="twm_slab" element={<TWMSlabConfig />} />
              <Route path="VendorSlab" element={<VendorApprovalSlab />} />
              <Route path="CostCenterTab" element={<CostCenterTab />} />
              <Route path="GLTab" element={<GLTab />} />
              <Route path="ProjectsTab" element={<ProjectsTab />} />
              <Route path="GstTab" element={<GstTab />} />
              <Route path="PO" element={<PoTab />} />
            </Route>
            <Route
              path="/Chat_Dashboard"
              element={<PrivateRoute Element={ChatPage} />}
            >
              <Route index element={<Chat_System />} />
              <Route path="/Chat_Dashboard/Chat" element={<Chat_System />} />
            </Route>
            ;
            <Route
              path="/GRN_Dashboard"
              element={<PrivateRoute Element={GrnPage} />}
            >
              <Route index element={<GRNSystem />} />
              <Route path="/GRN_Dashboard/GRN" element={<GRNSystem />} />
              <Route path="grn/:id" element={<GRNDetails />} />

            </Route>
            ;
            <Route
              path="/Buyer_dashboard"
              element={<PrivateRoute Element={BuyerDashboard} />}
            >
              <Route index element={<BuyerDashboardTab />} />

              <Route
                path="/Buyer_dashboard/Dashboard"
                element={<BuyerDashboardTab />}
              />
              <Route path="vendors" element={<BuyerVendorsTab />} />
              <Route
                path="/Buyer_dashboard/Items"
                element={<BuyerItemsTab />}
              />
              <Route
                path="/Buyer_dashboard/PR"
                element={<PurchaseRequisitionTab />}
              />

              <Route path="/Buyer_dashboard/RFQ" element={<BuyerRFQTab />} />

              <Route path="/Buyer_dashboard/QuickRFQ" element={<QuickRFQ />} />
              <Route path="/Buyer_dashboard/FreeRFQ" element={<FreeRFQ />} />
              <Route path="/Buyer_dashboard/FreeRFQ/view" element={<FreeRFQDetails />} />
              <Route
                path="/Buyer_dashboard/FreeRFQ/create"
                element={<FreeRFQCreate />}
              />
              <Route
                path="/Buyer_dashboard/Invite"
                element={<VendorTabLayout />}
              />
              <Route
                path="/Buyer_dashboard/UnifiedOnboarding"
                element={<UnifiedOnboarding />}
              />
              <Route
                path="/Buyer_dashboard/verification"
                element={<VendorVerifciationPartial />}
              />

              <Route
                path="/Buyer_dashboard/RFQ_Draft"
                element={<BuyerRFQDraftTab />}
              />
              <Route path="/Buyer_dashboard/PO" element={<PoTab />} />
              <Route
                path="/Buyer_dashboard/SalesInvoice"
                element={<SalesInvoiceTab />}
              />
              <Route
                path="/Buyer_dashboard/Comparison"
                element={<ComparisonTab />}
              />
              <Route
                path="/Buyer_dashboard/New_Comparison"
                element={<NewComparison />}
              />

              <Route
                path="/Buyer_dashboard/PanToCinUploader"
                element={<PanToCinUploader />}
              />

              <Route
                path="/Buyer_dashboard/ItemCategoryMap"
                element={<ItemVendorMap />}
              />

              <Route path="/Buyer_dashboard/MRP" element={<MRPTab />} />
              <Route
                path="/Buyer_dashboard/Inventory"
                element={<InventoryTab />}
              />
              <Route
                path="/Buyer_dashboard/Inventory_Master"
                element={<InventoryMasterWarehouse />}
              />
              <Route
                path="/Buyer_dashboard/Asset_Register"
                element={<AssetRegisterTab />}
              />
              <Route
                path="/Buyer_dashboard/Invoice"
                element={<InvoiceAutomation />}
              />
              <Route
                path="/Buyer_dashboard/InvoiceReconciliation"
                element={<InvoiceReconciliation />}
              />
              {/* <Route path="/Buyer_dashboard/Invoice" element={<InvoiceAutomation />} /> */}

              {/* <Route path="/Buyer_dashboard/Comparison_analytics" element={<ComparisonAnalyticsTab />} /> */}
              <Route path="My_profile" element={<MyProfile />} />

              <Route path="Matching" element={<TWMHome />} />
              <Route path="Service_Matching" element={<ServiceMatchingHome />} />
              <Route path="Invoice_PayAsYouGo" element={<PayPerUseHome />} />

              <Route path="vendor_approval" element={<VendorApproval />} />

              <Route path="rate_contract" element={<RateContract />} />
              <Route path="price_list" element={<PriceList />} />
              <Route
                path="price_list/create_quotation"
                element={<PriceListQuotationView />}
              />
              <Route
                path="Sourcing_Intelligence"
                element={<SourcingIntelligence />}
              />

              <Route path="rate_contract" element={<RateContract />} />

              <Route path="vendor_approval" element={<VendorApproval />} />

              <Route path="rate_contract" element={<RateContract />} />
            </Route>
            <Route
              path="/User_dashboard"
              element={<PrivateRoute Element={BuyerDashboard} />}
            >
              <Route index element={<BuyerDashboardTab />} />
              <Route
                path="/User_dashboard/Dashboard"
                element={<BuyerDashboardTab />}
              />

              <Route
                path="/User_dashboard/PR"
                element={<PurchaseRequisitionTab />}
              />
              <Route path="/User_dashboard/PO" element={<PoTab />} />
              <Route path="Invoice" element={<InvoiceAutomation />} />
              <Route
                path="Inventory_Master"
                element={<InventoryMasterWarehouse />}
              />
              <Route path="ApproveInvoice" element={<ApproverInvoice />} />
              <Route
                path="InvoiceReconciliation"
                element={<InvoiceReconciliation />}
              />
              <Route path="vendor_approval" element={<VendorApproval />} />
              <Route path="Matching" element={<TWMHome />} />
            </Route>
            <Route
              path="/Vendor_dashboard"
              element={<PrivateRoute Element={VendorDashboard} />}
            >
              <Route index element={<VendorDashboardTab />} />
              <Route path="Dashboard" element={<VendorDashboardTab />} />
              <Route path="RFQ" element={<VendorRFQTab />} />
              <Route path="PO" element={<VendorPOTab />} />
              <Route path="Vendor Invoice" element={<VendorInvoice />} />
              <Route path="InvoiceProcess" element={<InvoiceProcess />} />
              <Route path="AddInvoice" element={<AddInvoice />} />

              <Route path="Users" element={<VendorUsersTab />} />
              <Route path="My_profile" element={<VendorProfile />} />
            </Route>
            <Route
              path="/UnregisteredVendor_dashboard"
              element={<PrivateRoute Element={UnregisteredVendorDashboard} />}
            >
              <Route index element={<UnregisteredVendorCatalogTab />} />
              <Route path="catalog" element={<UnregisteredVendorCatalogTab />} />
              <Route
                path="catalog/add"
                element={<UnregisteredVendorCatalogAdd />}
              />
              <Route
                path="My_profile"
                element={<UnregisteredVendorMyProfile />}
              />
            </Route>
            <Route
              path="/Credit_dashboard"
              element={<PrivateRoute Element={CreditUser} />}
            >
              <Route index element={<CreditUserDashboard />} />
            </Route>
            <Route path="/home" element={<HomePage />} />
            <Route path="/" element={<HomePage />} />
            <Route
              path="/buyer_organization_signup"
              element={<BuyerSignup />}
            />
            {/* vendor signup will accept the Referral url when its available as ref_code
            --- otherwise it will not ---  */}
            <Route path="/vendor_signup" element={<VendorSignup />} />
            <Route path="/vendor_signup/:ref_code" element={<VendorSignup />} />
            <Route path="/unified_onboarding" element={<UnifiedOnboardingApplication />} />
            <Route path="/unified_onboarding/:ref_code" element={<UnifiedOnboardingApplication />} />
            <Route
              path="/unified_onboarding/:token/:onboarding_type"
              element={<UnifiedOnboardingApplication />}
            />
            <Route path="/poc_vendor_signup" element={<DemoVendorSignup />} />
            <Route
              path="/poc_Invoice_Automation"
              element={<DemoInvoiceAutomation />}
            />

            {/* email response routes */}
            <Route path="/public-submission" element={<PublicSubmission/>} />
          </Routes>
        </Suspense>
      </Router>
    <OfflinePasswordModal
  open={offlinePopupOpen}
  mode="offline"
  onClose={() => setOfflinePopupOpen(false)}
/>


    </div>
  );
}
export default App;
